import React, { Component } from "react";
import { FormControl } from "react-bootstrap";
import { observer } from "mobx-react";
import "./style.css";
import UnitBinding from "../../../UnitBinding";

class Unit extends Component {
  static defaultProps = {
    unit: new UnitBinding()
  };

  constructor(props) {
    super(props);
    this.state = { inputValue: null };
  }

  handleOnChange(e) {
    const { model, dataMember, unit } = this.props;

    let value = null;
    if (unit) {
      value = unit.parseDisplayValue(e.target.value);
    }

    this.setState({ inputValue: e.target.value });

    if (model && dataMember) {
      model[dataMember] = value;
    }
  }

  getValue() {
    const { model, dataMember } = this.props;
    let value = null;
    if (model && dataMember) {
      value = model[dataMember];
    }
    return value;
  }

  onFocus(e) {
    let value = this.getValue();
    const { unit } = this.props;
    let inputValue = "";
    if (value !== null && value !== undefined) {
      inputValue = unit.fullFormattedDisplayValue(value);
    }
    this.setState({ inputValue: inputValue });
  }

  onBlur(e) {
    this.setState({ inputValue: null });
  }

  onKeyDown(e) {
    // replace decimal point with accutual decimal character according to our the culture of
    // the string formatting lib
    const { unit } = this.props;
    if (unit && e.keyCode === 110 /* decimal point */) {
      e.preventDefault();
      console.log("onKeyDown: ", e.target);
      let selectionStart = e.target.selectionStart;
      const part1 = e.target.value.substr(0, e.target.selectionStart);
      const part2 = unit.decimalChar;
      const part3 = e.target.value.substr(e.target.selectionEnd);
      e.target.value = `${part1}${part2}${part3}`;
      selectionStart += part2.length;
      e.target.selectionStart = e.target.selectionEnd = selectionStart;
    }
  }

  render() {
    let { placeholder, unit } = this.props;

    let value = this.getValue();

    let displayValue = null;
    if (this.state.inputValue) {
      displayValue = this.state.inputValue;
    } else if (value && unit) {
      displayValue = unit.formatDisplayValue(value);
    }

    let unitLabel = null;
    if (unit && unit.UnitShortDescription !== "") {
      unitLabel = (
        <FormControl.Static>{unit.UnitShortDescription}</FormControl.Static>
      );
    }

    return (
      <div className="numeric-input">
        <FormControl
          value={displayValue || ""}
          onChange={this.handleOnChange.bind(this)}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
          onKeyDown={this.onKeyDown.bind(this)}
          placeholder={placeholder || ""}
        />
        {unitLabel}
      </div>
    );
  }
}

export default observer(Unit);



// WEBPACK FOOTER //
// ./src/Core/Components/Inputs/Unit/index.js